(function(){
  'use strict';
  if(window.location.pathname !== '/pages/about-us') return;

  function fix(){
    /* ── 重複挿入ガード ── */
    if(document.getElementById('zen-pharmacy-info-block')) return;

    /*
     * 戦略: "Profile of Kenji KIDERA" h3 を錨点にして、その直前に挿入する。
     * 「Company Information」h3 はページ本文に存在しないため使用しない。
     *
     * 錨点が見つからない場合のフォールバック:
     *   → 最初の .rte 要素の末尾に appendChild する
     */
    var allRtes = document.querySelectorAll('.rte');
    if(!allRtes || allRtes.length === 0){
      console.warn('[ZEN] about-fix.js v7: no .rte element found.');
      return;
    }

    /* ── 全 .rte から "Profile of Kenji" h3 を探す ── */
    var anchorH3 = null;
    var anchorRte = null;
    for(var r = 0; r < allRtes.length; r++){
      var h3s = allRtes[r].querySelectorAll('h3');
      for(var i = 0; i < h3s.length; i++){
        if(h3s[i].textContent.indexOf('Profile of Kenji') !== -1){
          anchorH3 = h3s[i];
          anchorRte = allRtes[r];
          break;
        }
      }
      if(anchorH3) break;
    }

    /* ── フォールバック: Profile h3 がない場合は最初の .rte 末尾に追加 ── */
    if(!anchorH3){
      console.warn('[ZEN] about-fix.js v7: "Profile of Kenji" h3 not found, falling back to .rte[0] append.');
      anchorRte = allRtes[0];
    }

    /* ── 薬局情報ブロックを生成 ── */
    var section = document.createElement('div');
    section.id = 'zen-pharmacy-info-block';
    section.style.cssText = 'margin: 2em 0; padding: 0;';

    section.innerHTML =

      /* ===== h2: Company Information ===== */
      '<h2 style="text-align:center; margin-bottom:1em;"><strong>Company Information</strong></h2>' +

      /* ===== 1. Dispensing Pharmacy ===== */
      '<h3 style="text-align:center;"><strong>Dispensing Pharmacy</strong></h3>' +

      '<table style="width:100%; border-collapse:collapse; margin-bottom:1.5em;">' +
        '<tbody>' +
          '<tr><td style="width:42%; padding:6px 8px; vertical-align:top;"><strong>Pharmacy Name</strong></td>' +
              '<td style="padding:6px 8px;">Kidera Pharmacy</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Pharmacy License No.</strong></td>' +
              '<td style="padding:6px 8px;">A-240007 (Valid through March 31, 2030)</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Medical Device Sales License No.</strong></td>' +
              '<td style="padding:6px 8px;">I-240010 (Valid through March 31, 2030)</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Pharmacy Founder / Owner</strong></td>' +
              '<td style="padding:6px 8px;">Kenji Kidera — Pharmacist License No. 380610</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Pharmacist-in-Charge</strong></td>' +
              '<td style="padding:6px 8px;">Shizuko Nakajima — Pharmacist License No. 171511</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Address</strong></td>' +
              '<td style="padding:6px 8px;">841-24 Tsuikiri, Shiroishi-cho, Kishima-gun, Saga 849-1103, Japan</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Phone</strong></td>' +
              '<td style="padding:6px 8px;">+81-952-97-7847</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Email</strong></td>' +
              '<td style="padding:6px 8px;"><a href="mailto:zen.pharmacy.japan@gmail.com">zen.pharmacy.japan@gmail.com</a></td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Business Hours</strong></td>' +
              '<td style="padding:6px 8px;">Mon–Fri 9:00–18:00 / Sat 9:00–13:00 (JST)</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Services</strong></td>' +
              '<td style="padding:6px 8px;">Prescription dispensing, OTC medicines, healthcare goods</td></tr>' +

          /* ===== 6. 有効期限管理 ===== */
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Expiration Date Management</strong></td>' +
              '<td style="padding:6px 8px;">All pharmaceutical products are managed and shipped with a minimum of 6 months remaining before the expiration date. Expiration dates are checked at the time of dispensing and confirmed on the product label.</td></tr>' +

          /* ===== 7. リスク区分 ===== */
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Drug Risk Classification</strong></td>' +
              '<td style="padding:6px 8px;">' +
                'Kidera Pharmacy handles pharmaceutical products in the following categories under Japanese law:<br>' +
                '<ul style="margin:6px 0 0 1.2em; padding:0;">' +
                  '<li><strong>Prescription Drugs</strong> — dispensed only upon receipt of a valid prescription from a licensed physician.</li>' +
                  '<li><strong>Category 1 OTC</strong> — sold under the supervision of a pharmacist.</li>' +
                  '<li><strong>Category 2 OTC</strong> — sold with written information provided by a pharmacist or registered seller.</li>' +
                  '<li><strong>Category 3 OTC</strong> — sold with information provided upon request.</li>' +
                '</ul>' +
              '</td></tr>' +

        '</tbody>' +
      '</table>' +

      /* ===== 2. Administrative & Export Operator ===== */
      '<h3 style="text-align:center;"><strong>Administrative &amp; Export Operator</strong></h3>' +

      '<table style="width:100%; border-collapse:collapse; margin-bottom:1.5em;">' +
        '<tbody>' +
          '<tr><td style="width:42%; padding:6px 8px; vertical-align:top;"><strong>Company Name</strong></td>' +
              '<td style="padding:6px 8px;">KIDERA Medical Service LLC</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Established</strong></td>' +
              '<td style="padding:6px 8px;">January 10, 2017</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Representative</strong></td>' +
              '<td style="padding:6px 8px;">Kenji Kidera</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Address</strong></td>' +
              '<td style="padding:6px 8px;">10822-1 Hakamano, Higashikawanobori-cho, Takeo-shi, Saga 843-0234, Japan</td></tr>' +
          '<tr><td style="padding:6px 8px; vertical-align:top;"><strong>Role</strong></td>' +
              '<td style="padding:6px 8px;">Administrative coordination and export-support services for ZEN PHARMACY JAPAN. ' +
              'Pharmaceutical dispensing and shipment are handled exclusively by Kidera Pharmacy.</td></tr>' +
        '</tbody>' +
      '</table>';

    /* ── 挿入: anchorH3 直前 or rte 末尾 ── */
    if(anchorH3){
      anchorH3.parentNode.insertBefore(section, anchorH3);
      console.log('[ZEN] about-fix.js v7: inserted before "Profile of Kenji" h3.');
    } else {
      anchorRte.appendChild(section);
      console.log('[ZEN] about-fix.js v7: appended to .rte[0] (fallback).');
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
